import { BriefWorkspace } from "../briefWorkspace";
import { Workspace } from "../workspace";

export const BriefWorkspaceMapper = {
  fromWorkspace: (workspace: Workspace): BriefWorkspace => ({
    id: workspace.id,
    name: workspace.config.name,
  }),
};
